import React from 'react';
import PropTypes from 'prop-types';
import { NumberFormatter } from '@mantine/core';
import { ChevronDown, ChevronUp } from 'tabler-icons-react';
import AppFlexbox from '../../common/AppFlexbox';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';

const OrderProductsCostInfo = ({ data, suffix, justifyContent }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const totals = data?.reduce(
    (r, c) => ({
      rate: r.rate + (c.rate || 0),
      amount: r.amount + c.amount
    }),
    { rate: 0, amount: 0 }
  );

  return (
    <AppStack
      onClick={() => setIsExpanded(!isExpanded)}
      style={{
        cursor: 'pointer',
        gap: 0,
        justifyContent: justifyContent || 'flex-end'
      }}
    >
      <AppFlexbox
        style={{
          gap: 5,
          justifyContent: justifyContent || 'flex-end'
        }}
      >
        <AppText style={{ fontSize: 14, color: '#666', textWrap: 'nowrap' }}>
          <NumberFormatter
            decimalScale={2}
            displayType="text"
            fixedDecimalScale
            prefix={totals.amount > 0 ? '+$' : '$'}
            thousandSeparator
            value={totals.amount / 100}
          />
          {totals.rate > 0 && (
            <>
              {' '}
              @{' '}
              <NumberFormatter
                decimalScale={2}
                displayType="text"
                suffix="%"
                thousandSeparator
                value={(totals.rate / 100) * 100}
              />
            </>
          )}
          {suffix && ` ${suffix}`}
        </AppText>
        {isExpanded ? (
          <ChevronUp color="#666" size={16} style={{ marginTop: 5 }} />
        ) : (
          <ChevronDown color="#666" size={16} style={{ marginTop: 5 }} />
        )}
      </AppFlexbox>

      {isExpanded && (
        <AppStack style={{ gap: 0 }}>
          {data?.map((d) => (
            <AppFlexbox
              key={d.name}
              style={{
                gap: 5,
                alignItems: 'center',
                justifyContent: 'space-between',
                color: '#666'
              }}
            >
              <AppText style={{ fontSize: 14 }}>
                {d.name}
                {d.rate && (
                  <>
                    {' '}
                    (
                    <NumberFormatter
                      decimalScale={2}
                      displayType="text"
                      suffix="%"
                      thousandSeparator
                      value={(d.rate / 100) * 100}
                    />
                    )
                  </>
                )}
              </AppText>
              <AppFlexbox>
                <AppText style={{ fontSize: 14, textWrap: 'nowrap', flex: 1 }}>
                  <NumberFormatter
                    decimalScale={2}
                    displayType="text"
                    fixedDecimalScale
                    prefix="$"
                    thousandSeparator
                    value={d.amount / 100}
                  />
                </AppText>
              </AppFlexbox>
            </AppFlexbox>
          ))}
        </AppStack>
      )}
    </AppStack>
  );
};

OrderProductsCostInfo.propTypes = {
  data: PropTypes.array,
  justifyContent: PropTypes.string,
  suffix: PropTypes.string
};

export default OrderProductsCostInfo;
